import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { TicketDetail } from '../components/TicketDetail';

export function TicketDetailRoute(): JSX.Element {
  const { t } = useTranslation();
  const { id = '' } = useParams();
  return (
    <main className="page stack">
      <h1>{t('support.ticketTitle')}</h1>
      <TicketDetail ticketId={id} />
    </main>
  );
}
